import { render, staticRenderFns } from "./NafakaAlacakKalemiForm.vue?vue&type=template&id=19c18fc2"
import script from "./NafakaAlacakKalemiForm.vue?vue&type=script&lang=ts"
export * from "./NafakaAlacakKalemiForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports